export const getToggleButtonFilterStyle = (components, { palette = {} } = {}) => ({
  button: {
    root: {
      minWidth: 110,
      borderColor: palette.neutralSecondary,
    },
    rootChecked: {
      backgroundColor: palette.white,
      borderColor: palette.themePrimary,
    },
    rootPressed: {
      borderWidth: 2,
    },
    rootCheckedPressed: {
      borderWidth: 2,
      backgroundColor: palette.themeLighterAlt,
    },
    rootCheckedHovered: {
      backgroundColor: palette.themeLighterAlt,
    },
    label: {
      fontWeight: 400,
    },
    labelChecked: {
      color: palette.themePrimary,
      fontWeight: 600,
    },
    iconChecked: {
      color: palette.themePrimary,
      fontWeight: 600,
    },
  },
});
